import { gql } from "@apollo/client";

const ACCEPT_OLA = gql`
  mutation acceptOLA3($olaID: String!, $email: String!, $name: String!, $position: String!, $institution: Int!, $status: String!) {
    acceptOLA3(olaID: $olaID, email: $email, name: $name, position: $position, institution: $institution, status: $status) 
  }
`;

export default ACCEPT_OLA;
